import { DateTime } from "luxon";
import GlobalConstants from "@constants";

// Note: All methods that takes strings need a string in the format from DateTime.toISOString()

export const convertToLocalTimeZone = (dateTimeAsIsoString: string) => {
  // Always assuming UTC input data
  return DateTime.fromISO(dateTimeAsIsoString, { zone: "utc" }).toLocal();
};

export const fromNow = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toRelative();
};

export const convertDateToLocalTime = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat(
    "yyyy-MM-dd h:mma"
  );
};

export const convertDateToLocalDate = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat("yyyy-MM-dd");
};

export const convertDateToLocalDateSlashes = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat("MM/dd/yyyy");
}

export const convertDateToLocalTimeString = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat(
    "MMM dd, yyyy hh:mm a"
  );
};

export const formatDateForData = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat("yyyy-MM-dd");
};

export const formatDateToStandard = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat(
    GlobalConstants.MuiGridFormats.dateFormat
  );
};

export const formatMessageDateToStandard = (dateTimeAsIsoString: string) => {
  return convertToLocalTimeZone(dateTimeAsIsoString).toFormat(
    GlobalConstants.MuiGridFormats.messageDateFormat
  );
};

export const convertDateToLocalDateWithExpiration = (
  dateTimeAsIsoString: string
) => {
  const convertedDateTime = convertToLocalTimeZone(dateTimeAsIsoString);
  const finalDate = convertedDateTime.toFormat(
    GlobalConstants.MuiGridFormats.dateFormat
  );
  const daysDiff = DateTime.now().diff(convertedDateTime, "days").days;
  return {
    finalDate,
    daysDiff,
  };
};

export const convertDateToUtcDateWithExpiration = (date: Date) => {
  const dateTime = DateTime.fromJSDate(date);

  const finalDate = dateTime
    .toUTC()
    .toFormat(GlobalConstants.MuiGridFormats.dateFormat);
  const daysDiff = DateTime.now().diff(dateTime, "days").days;
  return {
    finalDate,
    daysDiff,
  };
};
